import { render, staticRenderFns } from "./Orcamento.vue?vue&type=template&id=31c72fb1"
import script from "./Orcamento.vue?vue&type=script&lang=js"
export * from "./Orcamento.vue?vue&type=script&lang=js"
import style0 from "./Orcamento.vue?vue&type=style&index=0&id=31c72fb1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports